module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-1_CS-82c6173ae48eb741ba28088462ab870f.svg";